export default {
    all: [],
    config: {
        chargeTypes: []
    }
}



// WEBPACK FOOTER //
// ./src/modules/deals/components/show/quotations/store/state.js